/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "utils/cn";

import { ChevronDown } from "components/icons";
import { Button } from "components/ui/Button";

import s from "../Dropdown.module.css";
import { ISize, IVariant } from "components/ui/Button/interface";

interface IAnchor {
  hasChevron?: boolean;
  size?: ISize;
  variant?: IVariant;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

const DropDownAnchor = ({
  hasChevron = true,
  size = "xl",
  variant = "select",
  className = "",
  containerClassName = "",
  disabled = false,
  onClick = () => {},
  children,
  ...rest
}: IAnchor) => {
  return (
    <div
      className={cn("h-full relative", containerClassName)}
      test-id="v-n08mXA"
    >
      <Button
        as={"div"}
        type="button"
        role="button"
        disabled={disabled}
        size={size}
        variant={variant}
        className={cn("min-h-[45px] cursor-pointer", className)}
        onClick={onClick}
        {...rest}
        test-id="WW6mMOus"
      >
        {children}
        {hasChevron !== false && (
          <ChevronDown className={s.caretDown} test-id="taLwa7PP" />
        )}
      </Button>
    </div>
  );
};

export default DropDownAnchor;
